<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const showMessage = ref(false);
const message = ref('');
const timeoutId = ref(null);

function showToast({ message: msg, timeout = 3000 }) {
  message.value = msg;
  showMessage.value = true;

  if (timeoutId.value) {
    clearTimeout(timeoutId.value);
  }

  timeoutId.value = setTimeout(() => {
    showMessage.value = false;
  }, timeout);
}

onMounted(() => {
  window.showToast = showToast;
});

onBeforeUnmount(() => {
  if (timeoutId.value) {
    clearTimeout(timeoutId.value);
  }
  window.showToast = null;
});
</script>

<template>
  <div v-if="showMessage" class="toast">
    {{ message }}
  </div>
</template>

<style lang="scss" scoped>
@import '~/entries/index/index.scss';
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: rgba(247, 247, 249, 1);
  padding: 10px 20px;
  border-radius: 5px;
  z-index: 9999;
  white-space: nowrap;
  font-size: 26*$px;
  line-height: 36.4*$px;
}
</style>
